import styles from './RedesignModal.module.scss'
import { useEffect, useState } from "react";
import { Drawer } from "@material-ui/core";
import Close from "../../assets/icons/close.svg";
import Button from '@ingka/button';
import { GIO, GioModuleVar } from "@/utils/gioUtils";
import { useCSC } from "@/hooks";
import { BASE_SIZE, DoorType } from "@/common/CommonType";
import TemplateTool from "@/utils/template-tool";
import { usePaxConfig } from "@/reducers/paxReducer";

interface IProps {
  show: boolean,
  onClose: () => void,
}

const ResetTipsModal = (props: IProps) => {
  const { show, onClose } = props;

  const handleClose = () => {
    onClose();
  }

  return <>
    <Drawer anchor={"bottom"} ModalProps={{
      keepMounted: false,
    }} open={show}>
      <div className={styles.container}>
        <div className={styles.title}>
          <span></span>
          <div className={styles.icon}>
            <img src={Close} onClick={handleClose} alt=""/>
          </div>
        </div>
        <div className={styles.redesignInfo}></div>
        <Button className={styles.confirmButton} small fluid type='primary' text='我知道了' onClick={handleClose}/>
      </div>
    </Drawer>
  </>
}

export default ResetTipsModal;
